import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpRequest, HttpResponse, HttpErrorResponse, HttpHandler } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map } from 'rxjs/operators';
import { catchError } from 'rxjs/operators';
import { StorageService } from '../storage/storage.service';
import { Router } from '@angular/router';
import { LoaderService } from '../loader/loader.service';
import { CookieService } from 'ngx-cookie-service';
import { SessionPopupService } from '../session-expiry/session-popup.service';
import { SESSION_EXPIRY_MESSAGE, BROWSER_RESTRICTION_ERROR_CODE } from '../constant/commonConstant';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InterceptorService {
  constructor(
    private storageService: StorageService,
    private router: Router,
    private cookie: CookieService,
    private readonly loaderSerice: LoaderService,
    private sessionPopup: SessionPopupService
  ) {}

  parseTimeToMs(time: string): number {
    const [h, m, s] = time.split(':').map(Number);
    return (h * 3600 + m * 60 + s) * 1000;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const skipBWLoader = request.headers.has('X-Skip-BW-Loader');

    if (!skipBWLoader) {
      this.loaderSerice.assignAllrequests(request.url);
    }

    let tokenAuth: any;
    const Apptoken = (this.storageService.getData('appToken') && JSON.parse(this.storageService.getData('appToken'))) || this.storageService.getData('appToken');
    const usertoken = this.storageService.getData('userToken') && JSON.parse(this.storageService.getData('userToken'));
    const token = request.url.includes('authValid') || request.url.includes('FeatureFlags') ? (Apptoken && Apptoken.token) || '' : (usertoken && usertoken.token) || '';
    const xsrfToken = this.cookie.get('XSRF-TOKEN');

    if (token && !request.url.includes('newUserToken')) {
      tokenAuth = request.clone({
        headers: request.headers.delete('X-Skip-BW-Loader'),
        setHeaders: xsrfToken ? { Authorization: 'Bearer ' + token, 'X-XSRF-TOKEN': xsrfToken } : { Authorization: 'Bearer ' + token }
      });
    } else {
      tokenAuth = request.clone({
        headers: request.headers.delete('X-Skip-BW-Loader'),
        setHeaders: xsrfToken ? { 'X-XSRF-TOKEN': xsrfToken } : {}
      });
    }
    return next
      .handle(tokenAuth)
      .pipe(
        map((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            if (!skipBWLoader) {
              this.loaderSerice.removeUrlOnresponse(request.url);
            }
            const sessionTimeOutInterval = this.storageService.getData('sessionTimeOutInterval');
            if (sessionTimeOutInterval) {
              const extraMs = this.parseTimeToMs(sessionTimeOutInterval);
              const expiryTime = Date.now() + extraMs;
              this.storageService.setData('tokenExpiresIn', new Date(expiryTime).toISOString());
              this.sessionPopup.startWatching();
            }

            // todo
          }
          return event;
        })
      )
      .pipe(
        catchError((err: HttpEvent<any>) => {
          if (err instanceof HttpErrorResponse) {
            if (!skipBWLoader) {
              this.loaderSerice.removeUrlOnresponse(request.url);
            }

            if (err.error && err.error.result && err.error.result.statusCode === 401) {
              request.url;
              if (this.router.url.includes('ExtUserView')) {
                window.alert(SESSION_EXPIRY_MESSAGE);
                this.storageService.removeAllData();
                window.close();
              } else if (!request.url.includes('authValid')) {
                let isBrowserRestriction = false;
                if (err.error && err.error.result && err.error.result.errorCode) {
                  isBrowserRestriction = err.error.result.errorCode.includes(BROWSER_RESTRICTION_ERROR_CODE);
                }

                if (!isBrowserRestriction) {
                  let presentUrl = window.location.href;

                  let screenData = {
                    url: presentUrl,
                    rolePermission: this.storageService.getData('rolePermission'),
                    userPermission: this.storageService.getData('userPermission'),
                    userId: this.storageService.getData('userId'),
                    boardId: this.storageService.getData('loggedInBoard')
                  };

                  let lastCaptured = this.storageService.getData('lastCapturedScreen');
                  this.storageService.removeAllData();

                  if (!lastCaptured) {
                    this.storageService.setData('lastCapturedScreen', JSON.stringify(screenData));
                  } else {
                    this.storageService.setData('lastCapturedScreen', lastCaptured);
                  }

                  this.sessionPopup.open();
                } else {
                  this.storageService.removeAllData();
                  window.location.href = `${environment.baseUrl}browser-access-restriction`;
                }
              }
            }
            // todo
            return throwError(err);
          }
          return new Observable<HttpEvent<any>>();
        })
      );
  }
}

